import React, { useState, useEffect } from "react";
import axios from "../../utils/axiosConfig";
import { BASE_URL } from "../../utils/config";
import "../styles/AdminStaffsManager.css";

const API = "/api/staffs";

const AdminStaffsManager = () => {

const emptyForm = {
names:"",
stfdob:"",
stfdoa:"",
stfleft:"",
status:"Currently Working",
designation:"",
qualification:"",
marital:"",
gender:"",
specialization:"",
stfyoe:"",
achievement:"",
remarks:""
};

const [form,setForm] = useState(emptyForm);
const [file,setFile] = useState(null);
const [staffs,setStaffs] = useState([]);
const [editId,setEditId] = useState(null);
const [viewStaff,setViewStaff] = useState(null);


/* FETCH STAFFS */

const fetchStaffs = async () => {

try{

const res = await axios.get(API);

setStaffs(res.data);

}catch(err){

console.error(err);

}

};

useEffect(()=>{

fetchStaffs();

},[]);



/* INPUT CHANGE */

const handleChange = (e)=>{

setForm({

...form,
[e.target.name]:e.target.value

});

};



/* FORMAT ACHIEVEMENTS FOR EDIT */

const formatAchievements = (arr)=>{

if(!arr) return "";

if(Array.isArray(arr)) return arr.join("\n");

return arr;

};



/* SUBMIT */

const handleSubmit = async (e)=>{

e.preventDefault();

const data = new FormData();

Object.keys(form).forEach(key=>{

data.append(key,form[key]);

});

if(file){

data.append("imgpic",file);

}

try{

if(editId){

await axios.put(`${API}/update/${editId}`,data);

}else{

await axios.post(`${API}/create`,data);

}

setForm(emptyForm);
setFile(null);
setEditId(null);

fetchStaffs();

window.scrollTo({top:0,behavior:"smooth"});

}catch(err){

console.error(err);

}

};



/* EDIT */

const handleEdit = (staff)=>{

setForm({

...staff,

achievement: formatAchievements(staff.achievement)

});

setEditId(staff.id);

window.scrollTo({top:0,behavior:"smooth"});

};



/* DELETE */

const handleDelete = async (id)=>{
  if(!window.confirm("Delete this staff?")) return;

  try {
    await axios.delete(`${API}/${id}`);
    fetchStaffs();
  } catch(err){
    console.error(err);
  }
};



return (

<div className="staff-admin-container">

<h2>Staff Management</h2>



{/* ADD / EDIT FORM */}

<form className="staff-form" onSubmit={handleSubmit}>

<input
name="names"
value={form.names}
onChange={handleChange}
placeholder="Full Name"
required
/>

<input
name="designation"
value={form.designation}
onChange={handleChange}
placeholder="Designation"
/>


{/* <input
type="date"
name="stfdob"
value={form.stfdob}
onChange={handleChange}
placeholder="Date of Birth"
/> */}
<label>
  Date of Birth :
  <input
    type="date"
    name="stfdob"
    value={form.stfdob}
    onChange={handleChange}
  />
</label>

{/* <input
type="date"
name="stfdoa"
value={form.stfdoa}
onChange={handleChange}
/> */}
<label>
  Date of Appointment :
  <input
    type="date"
    name="stfdoa"
    value={form.stfdoa}
    onChange={handleChange}
  />
</label>

{/* <input
type="date"
name="stfleft"
value={form.stfleft}
onChange={handleChange}
/> */}
<label>
  Date of Job Left :
  <input
    type="date"
    name="stfleft"
    value={form.stfleft}
    onChange={handleChange}
  />
</label>

<select
name="gender"
value={form.gender}
onChange={handleChange}
required
>

<option value="">Gender</option>
<option value="Male">Male</option>
<option value="Female">Female</option>

</select>



<select
name="marital"
value={form.marital}
onChange={handleChange}
required
>

<option value="">Marital Status</option>
<option value="Single">Single</option>
<option value="Married">Married</option>

</select>


<input
name="stfyoe"
value={form.stfyoe}
onChange={handleChange}
placeholder="Years of Experience"
/>

<select name="status" value={form.status} onChange={handleChange}>
  <option value="Currently Working">Currently Working</option>
  <option value="Left">Left</option>
</select>


<textarea
name="qualification"
value={form.qualification}
onChange={handleChange}
placeholder="Qualification"
/>


<textarea
name="specialization"
value={form.specialization}
onChange={handleChange}
placeholder="Specialization"
/>


<textarea
name="achievement"
value={form.achievement}
onChange={handleChange}
placeholder="Achievements (one per line)"
/>


<textarea
name="remarks"
value={form.remarks}
onChange={handleChange}
placeholder="Remarks"
/>


<input
type="file"
onChange={(e)=>setFile(e.target.files[0])}
/>


<button type="submit">

{editId ? "Update Staff" : "Add Staff"}

</button>

</form>



{/* GRID LIST */}

<h3 className="grid-title">Staff List</h3>

<table className="staff-grid">

<thead>

<tr>

{/* <th>ID</th> */}
<th>Photo</th>
<th>Name</th>
<th>Designation</th>
<th>DOB</th>
<th>DOA</th>
<th>Action</th>

</tr>

</thead>


<tbody>

{staffs.map((s)=>(

<tr key={s.id}>

{/* <td>{s.id}</td> */}

<td>

<img
  src={`${BASE_URL}/uploads/staffs/${s.imgpic || "female-avatar.jpg"}`}
  alt=""
/>

</td>

<td>{s.names}</td>

<td>{s.designation}</td>

<td>{s.stfdob}</td>

<td>{s.stfdoa}</td>

<td>

<button
className="view-btn"
onClick={()=>setViewStaff(s)}
>
View
</button>

<button
className="edit-btn"
onClick={()=>handleEdit(s)}
>
Edit
</button>

<button
className="delete-btn"
onClick={()=>handleDelete(s.id)}
>
Delete
</button>

</td>

</tr>

))}

</tbody>

</table>



{/* VIEW MODAL */}

{viewStaff && (

<div className="modal-overlay">

<div className="staff-modal">

<button
className="close-btn"
onClick={()=>setViewStaff(null)}
>
Close
</button>

<div className="modal-body">

<div className="modal-photo">

<img
src={`${BASE_URL}/uploads/staffs/${viewStaff.imgpic}`}
alt=""
/>

</div>

<div className="modal-details">

<h3>{viewStaff.names}</h3>

<p><b>Designation:</b> {viewStaff.designation}</p>

<p><b>DOB:</b> {viewStaff.stfdob}</p>

<p><b>Date of Appointment:</b> {viewStaff.stfdoa}</p>

<p><b>Gender:</b> {viewStaff.gender}</p>

<p><b>Marital:</b> {viewStaff.marital}</p>

<p><b>Job Status:</b> {viewStaff.status}</p>

<p><b>Qualification:</b> {viewStaff.qualification}</p>

<p><b>Specialization:</b> {viewStaff.specialization}</p>

<p><b>Experience:</b> {viewStaff.stfyoe}</p>

<p><b>Achievements:</b></p>

<ul>

{Array.isArray(viewStaff.achievement) ?

viewStaff.achievement.map((a,i)=>(

<li key={i}>{a}</li>

))

:

<li>{viewStaff.achievement}</li>

}

</ul>

<p><b>Remarks:</b> {viewStaff.remarks}</p>

</div>

</div>

</div>

</div>

)}

</div>

);

};

export default AdminStaffsManager;